import { render, staticRenderFns } from "./GenerateSDK.vue?vue&type=template&id=c8caff00"
import script from "./GenerateSDK.vue?vue&type=script&lang=js"
export * from "./GenerateSDK.vue?vue&type=script&lang=js"
import style0 from "./GenerateSDK.vue?vue&type=style&index=0&id=c8caff00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports